import React from 'react';
import stores from '../../functions/stores.json';

interface CarouselTypes {}

export const Carousel: React.FC<CarouselTypes> = () => {
    return (
        <div className="am_carousel_wrapper">
            <div className="am_carousel_content">
                {stores.map((store) => (
                    <div key={store.PK} className="am_carousel_card">
                        <div className="am_carousel_inner_card">
                            <p>{store.PK}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
